<div class="d-flex">
<dxc-text-input
    label="{{label | translate}}"
    id = "id"
    [disabled]="disabled"
    [value]="model"
    (onChange)="onAppend($event)"
    (onBlur)="onBlur($event)"
    margin="margin"
    [error]="errorMessage"
    [maxLength]="maxLength"
    [class.required]="required"
    placeholder="{{placeholder | translate}}"
  >
</dxc-text-input>
<img *ngIf="suffix" class="searchButton" [src]="image" alt="img search" (click)="serchIcon()"/>
</div>